import { SxProps, Theme } from '@mui/material/styles';

export const notFoundStyles = {
    root: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 3,
    } satisfies SxProps<Theme>,
    title: {
        fontSize: { xs: '6rem', sm: '8rem' },
    } satisfies SxProps<Theme>,
};
